import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgBelangrijkeDocumenten = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F18700"
      fillRule="evenodd"
      d="m18.2 6.63-5.35-.735-.76 5.52-2.78 20.24 17.835 2.45 2.78-20.24.38-2.775.375-2.745L18.195 6.63zM19 25.5h-6v-1h6zm3-3h-9v-1h9zm0-8h-9v-1h9zm1-3H13v-1h10z"
      clipRule="evenodd"
    />
    <mask
      id="Belangrijke_documenten_svg__a"
      width={18}
      height={26}
      x={11}
      y={7}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M16.4 7H11v26h18V7z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#Belangrijke_documenten_svg__a)">
      <path
        fill="#FED27A"
        d="m-4.495 5.86 12.25 7.07L14.825.68zM7.755 12.93.68 25.175 20 20z"
      />
      <path
        fill="#F7A941"
        d="m5.86 44.495 7.07-12.245L.68 25.175zM25.175 39.32l7.07-12.25L20 20"
      />
      <path
        fill="#FED27A"
        d="m20 20-7.07 12.25 12.245 7.07zM34.14-4.495 14.825.68 27.07 7.75zM39.32 14.825 27.07 7.75 20 20z"
      />
      <path
        fill="#F7A941"
        d="m5.86 44.495 19.315-5.175-12.245-7.07z"
      />
      <path
        fill="#FED27A"
        d="m.68 25.175 12.25 7.075L20 20zM20 20l12.245 7.07 7.075-12.245zM44.495 34.14l-12.25-7.07-7.07 12.25zM20 20l7.07-12.25L14.825.68"
      />
      <path
        fill="#FED27A"
        d="m14.825.68-7.07 12.25L20 20zM34.14-4.495 27.07 7.75l12.25 7.075z"
      />
    </g>
    <path
      fill="#fff"
      d="M19 24.5h-6v1h6zM22 21.5h-9v1h9zM22 13.5h-9v1h9zM23 10.5H13v1h10z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgBelangrijkeDocumenten);

export default ForwardRef;
